/**
 * CI builds this app once and deploys the same bundle to every page-hosting
 * env (see `creditAcceptancePageHosting.deploy` in package.json), so a
 * build-time `import.meta.env` value can't vary per env. The CAPS target
 * is looked up at runtime instead, keyed by the page-hosting host this
 * bundle actually ended up served from. Mirrors the host guard in useAuth.ts.
 */
const CAPS_URL_BY_HOST: Record<string, string> = {
  "ui.creditacceptance.com": "https://caps.creditacceptance.com/steps/pages/workqueue/workQueue.jsf",
  "uiqa.creditacceptance.com": "https://capsqa.creditacceptance.com/steps/pages/workqueue/workQueue.jsf",
  "uitest.creditacceptance.com": "https://capstst3.creditacceptance.com/steps/pages/workqueue/workQueue.jsf",
  "uilab.creditacceptance.com": "https://capstst3.creditacceptance.com/steps/pages/workqueue/workQueue.jsf",
};

/**
 * Navigates back to the site that redirected the user into the workbench
 * (e.g. the CAPS work queue). No-ops on hosts with no known CAPS target
 * (local dev, `pnpm preview`, Playwright's preview server).
 * @returns {void}
 */
export function redirectToOriginSite(): void {
  const url = CAPS_URL_BY_HOST[globalThis.location.host];
  if (!url) {
    return;
  }
  globalThis.location.assign(url);
}
